var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBombTvlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    height: 277.8,
    width: 226.2,
    x: 37.7,
    y: -289
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD918",
    d: "M146.6,11.1c2.8,0,5.6,0,8.3,0c1.2,0.2,2.3,0.4,3.5,0.6c5.1,0.8,10.2,1.2,15.2,2.3 c10.7,2.3,20.5,6.8,29.5,12.8c15.4,10.5,26.5,24.2,33.1,41.1c2.8,7.1,4.8,14.5,5.2,22c0.6,9.6,0.4,19.2,0.6,28.8 c0.1,4.8,0,4.8,5,4.8c5.6,0,9.7,2.3,12.8,6.6c3.2,4.4,4,9.3,4,14.4c0.1,40.6,0.1,81.1,0,121.7c0,3.3-0.3,6.8-1.2,10 c-2.2,7.8-8,12.8-17,12.8c-63.4,0-126.8,0-190.2,0c-5.7,0-10.4-2.3-13.7-6.9c-3.1-4.3-4-9.2-4-14.2c0-40.9,0-81.9,0-122.8 c0-2.9,0.3-5.9,1-8.7c1.5-5.4,4.5-9.9,10.4-11.9c1.8-0.6,3.9-0.8,5.8-0.8c4.5-0.1,4.5,0,4.5-4.4c0-5.6-0.1-11.2,0-16.9 c0.1-8.4,0.7-16.8,2.8-25c3.3-12.8,9.3-24.2,18-34.4c9.8-11.4,21.9-20,36.4-25.4c8.4-3.2,17-5.3,26.1-5.7 C144.1,11.7,145.3,11.3,146.6,11.1z M150.6,123.5c17.2,0,34.4,0,51.6,0c1.7,0,2.4-0.3,2.3-2c-0.2-1.8,0-3.6,0-5.4 c-0.2-8.5,0.1-17-0.7-25.4c-1.2-11.8-7.2-21.6-16.2-29.8c-7.7-7-16.9-11.4-27.4-13.2c-9.3-1.6-18.4-0.8-27.3,2.2 c-9,3.1-16.6,8.1-22.8,15c-7.8,8.7-12.3,18.7-12.9,30.1c-0.4,8.9-0.1,17.7-0.2,26.6c0,1.7,0.6,2.1,2.3,2 C116.4,123.5,133.5,123.5,150.6,123.5z M169.2,225.6c0-5.9,0.1-11.7,0-17.6c0-1.5,0.5-2.7,1.5-3.8c7.1-7.9,7.3-20.4,0.7-28.6 c-4.3-5.4-10-8.6-17.1-9.3c-5.3-0.5-10.5-0.1-15.3,2.1c-14.4,6.7-18.3,24.6-8,36.2c0.7,0.8,1.2,2.1,1.2,3.1 c0.1,11.9,0,23.9,0.1,35.8c0,5.6,3.8,9.1,9.6,9.1c5.8,0,11.6,0,17.5,0c6.1,0,9.8-3.6,9.8-9.4C169.2,237.3,169.2,231.5,169.2,225.6z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombTvlIcon);
export default __webpack_public_path__ + "static/media/bomb-TVL-icon.a7f6ab23f23e13c0a35c836e70d8d6af.svg";
export { ForwardRef as ReactComponent };